export default __webpack_public_path__ + "3625d00258dae14dbd3b7b6d54e111df.jpg";